/** @format */

import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import { Line } from "react-chartjs-2";
import Card from "./Card";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler
);

const options = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
    title: {
      display: false,
    },
    datalabels: {
      display: false,
    },
    tooltip: {
      backgroundColor: "#1f2937",
      titleColor: "#fff",
      bodyColor: "#d1d5db",
      borderColor: "#4b5563",
      borderWidth: 1,
      callbacks: {
        title: (context) => `Sana: ${context[0].label}`, // Tooltipda sanani chiroyli ko'rsatadi
        label: (context) => `${context.formattedValue} m³/s`,
      },
    },
  },
  scales: {
    y: {
      grid: {
        color: "#E5E7EB",
        borderDash: [4, 4],
      },
      ticks: {
        color: "#6B7280",
      },
      beginAtZero: true,
    },
    x: {
      grid: {
        drawOnChartArea: false,
        color: "#B5B5C3",
      },
      ticks: {
        color: "#6B7280",
        minRotation: 0,
        maxRotation: 0,
        autoSkip: true, // Labellar ko'payib ketsa, avtomat qisqartiradi
      },
    },
  },
  elements: {
    point: {
      radius: 3,
      hoverRadius: 4,
      backgroundColor: "#3B82F6",
      borderWidth: 1,
      borderColor: "#fff",
    },
    line: {
      tension: 0.4,
    },
  },
};

const Chart6 = ({ data, labels }) => {
  // TUZATILDI: labels props orqali ota komponentdan (BoshSahifa yoki mos sahifadan) kirib kelishi kerak

  const gradient = (ctx) => {
    const chart = ctx.chart;
    const { ctx: context, chartArea } = chart;
    if (!chartArea) return null;

    const gradient = context.createLinearGradient(
        0,
        chartArea.top,
        0,
        chartArea.bottom
    );
    gradient.addColorStop(0, "rgba(59,130,246,0.3)");
    gradient.addColorStop(1, "rgba(59,130,246,0)");

    return gradient;
  };

  const datas = {
    // TUZATILDI: Agar tashqaridan haqiqiy labels kelsa o'shani oladi, bo'lmasa bo'sh qoldiradi
    labels: labels || [],
    datasets: [
      {
        label: "m3/s",
        data: data,
        borderColor: "#3B82F6",
        backgroundColor: gradient,
        fill: true,
      },
    ],
  };

  return (
      <Card>
        <div className='chart-box-all'>
          <div>
            <h4 className='chart-title'>
              Qizilqishloq G/P{" "}
              <span className='lower' style={{ opacity: 0.75, marginLeft: '4px' }}>
              kunlik (m<sup>3</sup>/s)
            </span>
            </h4>

            <Line options={options} data={datas} height={80} />
          </div>
        </div>
      </Card>
  );
};

export default Chart6;